'use client'

import React, { PropsWithChildren } from 'react'

import { cn } from '@app/utils'

import { ExportCSV } from './ExportCSV'
import { FilterButton } from './FilterButton'
import { ResetFilters } from './ResetFilters'
import { ExportAllOpps } from './ExportAllOpps'
export function GridHeader(props: React.PropsWithChildren) {
  let content

  if (props.children) {
    content = props.children
  } else {
    content = (
      <>
        <ResetFilters />
        <ExportCSV />
      </>
    )
  }

  return <div className={cn('p-s flex w-full flex-row items-center gap-2xs')}>{content}</div>
}

function Spacer() {
  return <div className="mx-auto"></div>
}

function Title(props: PropsWithChildren) {
  return <h2 className="text-sm font-semibold text-true-black">{props.children}</h2>
}
GridHeader.FilterButton = FilterButton
GridHeader.ResetFilters = ResetFilters
GridHeader.ExportCSV = ExportCSV
GridHeader.ExportAllOpps = ExportAllOpps
GridHeader.Spacer = Spacer
GridHeader.Title = Title
